import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import { doAccessAction } from 'store/actions/role-list.actions';
import {
  changeDataProcessingState,
  getActivityNew,
} from 'store/actions/activity.actions';
import { Loader } from 'components';
import ComplexSuccessIcon from 'components/SvgIcons/ComplexIcons/success.svg';
import ComplexCrossIcon from 'components/SvgIcons/ComplexIcons/cross.svg';
import { getTextAlertUnlink } from 'utils/getTextContext';
import { getTextAlertErrorHandler } from 'utils/getTextContext';
import { ROLES } from 'config/constants';
import { MODAL_TYPES } from '../constants';
import { NotesForm } from './NotesForm';

@connect(
  ({ roleList: { processing = {}, sponsorProfileRequests = {} } }, props) => ({
    processing: processing[`disconnect-${props.options.userId}`],
    sponsorProfileRequests,
  }),
  (dispatch) => ({
    doAccessAction: bindActionCreators(doAccessAction, dispatch),
    changeDataProcessingState: bindActionCreators(
      changeDataProcessingState,
      dispatch,
    ),
    getActivityNew: bindActionCreators(getActivityNew, dispatch),
  }),
)
class UnlinkModal extends React.PureComponent {
  static propTypes = {
    doAccessAction: PropTypes.func,
    changeDataProcessingState: PropTypes.func,
    getActivityNew: PropTypes.func,
    options: PropTypes.shape({
      userRole: PropTypes.string,
      userId: PropTypes.string,
      listDataKey: PropTypes.string,
      actionCb: PropTypes.func,
    }),
  };

  static defaultProps = {
    options: {},
  };

  handleSubmit = async (values) => {
    const {
      doAccessAction,
      showModal,
      changeDataProcessingState,
      options: {
        requestId,
        userId,
        groups,
        listDataKey,
        actionCb,
        url,
        method = 'put',
        userRole,
        handleReloadPage,
        handleSetAccountDataFlag,
      } = {},
    } = this.props;
    changeDataProcessingState(true, 'processingActivityNew');

    const response = await doAccessAction({
      requestMethod: method,
      url,
      body: { ...values },
      requestId: requestId && requestId,
      processingKey: `disconnect-${userId}`,
      stateKeyForDataSaving: listDataKey,
      rewriteAccessRequestKey: requestId && 'requestId',
    });

    if (!response || response.code !== 'success') {
      changeDataProcessingState(false, 'processingActivityNew');
      return showModal(MODAL_TYPES.INFO, {
        withCross: false,
        icon: <ComplexCrossIcon />,
        ...getTextAlertErrorHandler(response.errors || [], {
          data: response.data || {},
          isPersonnel: groups.includes(ROLES.PERSONNEL),
        }),
        additionalClassName: 'p-15',
      });
    }

    showModal(MODAL_TYPES.INFO, {
      withCross: false,
      icon: <ComplexSuccessIcon />,
      ...getTextAlertUnlink(userRole),
      additionalClassName: 'p-15',
      style: { maxWidth: '548px' },
      handleReloadPage: handleReloadPage,
      handleSetAccountDataFlag: handleSetAccountDataFlag,
    });
    actionCb && actionCb();
  };

  render() {
    const { hideModal, options: { fullName, userRole = '' } = {} } = this.props;
    const userRoleTitle = userRole.replace(/([A-Z])/g, ' $1');

    return (
      <Loader isShow={this.props.processing}>
        <div className="white-box p-15 text-left" style={{ maxWidth: '550px' }}>
          <div className="montserrat bold fs-16">Unlink {fullName}</div>
          <div className="fs-12 mt-2">
            Unlinking will delete your profile from this {userRoleTitle}. Are
            you sure you want to unlink? You will no longer be able to access{' '}
            {userRoleTitle} profile information.
          </div>
          <NotesForm
            notesPlaceholder="Enter text"
            onSubmit={this.handleSubmit}
            hideModal={hideModal}
          />
        </div>
      </Loader>
    );
  }
}

export { UnlinkModal };
